const autoPublicPath = require("./auto-public-path").autoPublicPath;

autoPublicPath(2);
